import React, { Suspense, lazy } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import ScrollToTop from "./Components/ScrollToTop";

// Logistics Website Components
import Subpage from "./Components/Subpage";
import Navbar from "./Components/Navbar";

import ProtectedRoute from "./Components/ProtectedRoute";

// ESWAR Workforce App Components
const Login = lazy(() => import("./pages/Auth/Login"));
const Register = lazy(() => import("./pages/Auth/Register"));
const AdminDashboard = lazy(() => import("./pages/Dashboards/AdminDashboard"));

function App() {
  return (
    <Router basename={process.env.PUBLIC_URL || undefined}>
      <ScrollToTop />
      <Suspense fallback={<div style={{ color: 'white', textAlign: 'center', marginTop: '20vh' }}>Loading...</div>}>
        <Routes>
          {/* ESWAR Unified Login */}
          <Route path="/login" element={<Login />} />
          {/* <Route path="/register" element={<Register />} /> */}

          {/* Protected Dashboards Strategy */}
          <Route
            path="/dashboard/admin"
            element={
              <ProtectedRoute>
                <AdminDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/dashboard/driver"
            element={
              <ProtectedRoute>
                <AdminDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/dashboard/manager"
            element={
              <ProtectedRoute>
                <AdminDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/dashboard/employee"
            element={
              <ProtectedRoute>
                <AdminDashboard />
              </ProtectedRoute>
            }
          />

          {/* Catch-all Logistics Website public routes */}
          <Route
            path="/*"
            element={
              <>
                <Navbar />
                <Subpage />
              </>
            }
          />
        </Routes>
      </Suspense>
    </Router>
  );
}

export default App;
